"use client";

import { useEffect } from "react";
import { startSsoProbe } from "@/lib/sso/probe";

/**
 * Silent SSO probe (multi-domena, ticket-based).
 *
 * Renderowany przez `PublicLayout` gdy: brak sesji frontendu i brak markera
 * `sso_probed` (max 1 probe per okno). Po hydratacji robi
 * top-level redirect na IdP `/ISSO/authorize?prompt=none` - gdy user ma master-sesję
 * na hoście backendu, wraca z `sso_ticket` (callback go redeemuje i ustawia sesję);
 * gdy nie, wraca z `sso=none` (callback ustawia marker, brak pętli).
 *
 * Client-side (nie SSR/middleware): boty bez JS widzą normalny SSR (SEO bez regresji);
 * redirect dotyka tylko realnych przeglądarek anonimowych użytkowników.
 *
 * Obsługuje WEJŚCIE na front. Kartę już otwartą, w której użytkownik zalogował się
 * w międzyczasie w panelu, obsługuje `<AdminSessionPoll>` - oba korzystają z tego
 * samego `startSsoProbe`.
 */
export function SsoProbe({ apiBase }: { apiBase: string }) {
  useEffect(() => {
    startSsoProbe(apiBase);
  }, [apiBase]);

  return null;
}
